import React from 'react';
import { BodyText, DataGrid, IFilteredDataGridColumnProps } from 'ui-toolkit';
import { IFeatureRoleData } from '../../../types/administration/features/IFeature';
import { FeatureRoleMenuDropdown } from './subComponents/FeatureRoleMenuDropdown';

export interface IFeatureRolesTableProps {
  data: IFeatureRoleData[];
  isFetching: boolean;
}

const columns: IFilteredDataGridColumnProps<IFeatureRoleData>[] = [
  {
    dataField: 'name',
    headerStyle: { width: '120px' },
    text: 'Name',
  },
  {
    dataField: 'description',
    headerStyle: { width: '100px' },
    text: 'Description',
  },
  {
    dataField: 'roleName',
    headerStyle: { width: '100px' },
    text: 'Role',
  },
  {
    dataField: 'isOn',
    headerStyle: { width: '100px' },
    formatter: (column, row) => {
      return <BodyText>{row.isOn ? 'Active' : 'Deactivated'}</BodyText>;
    },
    text: 'Is On',
  },
  {
    dataField: 'feature.menu',
    headerStyle: { width: '48px' },
    formatter: (column, row) => {
      return <FeatureRoleMenuDropdown feature={row} />;
    },
    text: '',
  },
];

export const FeatureRolesTable: React.FC<IFeatureRolesTableProps> = ({ data, isFetching }) => {
  return <DataGrid columns={columns} data={data} keyField="compositeKey" loading={isFetching} remote />;
};
